import React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
const StyledText = styled.p`
  margin-bottom: 0;
`;
const Violation = ({ text, severity = void 0 }) => {
  switch (severity) {
    case "warning":
      return /* @__PURE__ */ React.createElement(StyledText, null, /* @__PURE__ */ React.createElement(Icon, { name: "warning", className: "text-danger" }), " ", text);
    case "info":
      return /* @__PURE__ */ React.createElement(StyledText, null, text);
    default:
      return /* @__PURE__ */ React.createElement(StyledText, null, /* @__PURE__ */ React.createElement(Icon, { name: "check", className: "text-success" }), " ", text);
  }
};
export default Violation;
